import { MappedResult } from '../mapped/index.mjs';
import { Extends } from './extends.mjs';
// prettier-ignore
function FromProperties(P, Right, True, False, options) {
    return globalThis.Object.getOwnPropertyNames(P).reduce((Acc, K2) => {
        return { ...Acc, [K2]: Extends(P[K2], Right, True, False, options) };
    }, {});
}
// prettier-ignore
function FromMappedResult(Left, Right, True, False, options) {
    return FromProperties(Left.properties, Right, True, False, options);
}
// prettier-ignore
export function ExtendsFromMappedResult(Left, Right, True, False, options) {
    const P = FromMappedResult(Left, Right, True, False, options);
    return MappedResult(P);
}
